function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.223 1.363L5.503 7l5.279-5.638a.819.819 0 00-.02-1.137.767.767 0 00-1.103.021L5.502 4.687 1.341.247A.767.767 0 00.239.225a.819.819 0 00-.02 1.137h.004z"
});
function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 11 7"
  }, props), _ref);
}
export default SvgCaretDown;